/**
 * Open a sized browser window with address bar and toolbar (for OBS / copy URL).
 * Use popup=no — popup=yes strips browser chrome including the omnibox.
 * Do not pass noopener/noreferrer in windowFeatures (not valid there).
 */
export function browserPopupFeatures(width, height) {
    return [
        "popup=no",
        "location=yes",
        "toolbar=yes",
        "menubar=no",
        `width=${width}`,
        `height=${height}`,
        "left=80",
        "top=40",
        "resizable=yes",
        "scrollbars=yes",
    ].join(",");
}

export function openBrowserPopup(url, windowName, width, height) {
    if (typeof window === "undefined") return null;
    const opened = window.open(url, windowName, browserPopupFeatures(width, height));
    if (opened) {
        opened.opener = null;
    }
    return opened;
}

export const SCREENSHOT_LINKS_POPUP = "puzzle-screenshot-links";
export const CAPTURE_PAGE_POPUP = "puzzle-capture-page";

/** Links index popup from Admin welcome. */
export function openScreenshotLinksPopup(url) {
    return openBrowserPopup(url, SCREENSHOT_LINKS_POPUP, 780, 860);
}

/** Single capture page with browser toolbar for OBS. */
export function openCapturePagePopup(
    url,
    windowName = CAPTURE_PAGE_POPUP,
    width = 405,
    height = 780,
) {
    return openBrowserPopup(url, windowName, width, height);
}

/** All screenshots gallery — wide window with horizontal preview row. */
export function openScreenshotGalleryPopup(url, windowName = "puzzle-screenshot-gallery") {
    return openBrowserPopup(url, windowName, 1680, 920);
}
